import {
  AbstractControl,
  AsyncValidatorFn,
  ValidationErrors,
  ValidatorFn,
} from '@angular/forms';
import { LocationData } from '@sc/data-access-models';
import { Observable } from 'rxjs';
import { filter, map, take } from 'rxjs/operators';

export class CustomValidators {
  static atLeastOneOfTwo(firstControl, secondControl): ValidatorFn {
    return (control: AbstractControl): ValidationErrors | null => {
      const firstControlValue = control.get(firstControl).value;
      const secondControlValue = control.get(secondControl).value;
      if (!firstControlValue && !secondControlValue) {
        return { noMatch: true };
      }
      return null;
    };
  }

  static atLeastOneSuggestion(
    next: Observable<boolean>,
    getSuggestions: () => LocationData[]
  ): AsyncValidatorFn {
    return (control: AbstractControl): Observable<ValidationErrors> => {
      return next.pipe(
        filter((value) => !value),
        map(() => {
          return getSuggestions()?.length > 0
            ? null
            : { address_not_in_suggestion: true };
        }),
        take(1)
      );
    };
  }

  static locationHasPlaceId(defaultLocation?: () => LocationData): ValidatorFn {
    return (
      control: AbstractControl<LocationData>
    ): ValidationErrors | null => {
      const hasPlaceId =
        !!control?.value?.placeId || !!defaultLocation?.()?.placeId;

      if (!hasPlaceId) {
        return {
          location_without_placeid: true,
        };
      }

      return null;
    };
  }
}

export class UtilsValidators {
  static hasRequiredValidator(control: AbstractControl): boolean {
    if (control?.validator) {
      const validator = control.validator({} as AbstractControl);
      if (validator && validator.required) {
        return true;
      }
    }
    return false;
  }
}
